var _rect, _path, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#f5c842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 15,
    height: 20,
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.5 C3 3.5 2 3.5 2 4.5 L2 20.5 C2 21.5 3 22 3 22"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3.5,
    x2: 3,
    y2: 21.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 4.5,
    x2: 10.5,
    y2: 9.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 7,
    x2: 13,
    y2: 7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 14,
    x2: 15,
    y2: 14
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 17,
    x2: 13,
    y2: 17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f94610f893150608a7b2ed242b963165.svg";
export { ForwardRef as ReactComponent };